import { IMGS_PATH } from 'constants/image';
import clsx from 'clsx';
import { sanitizeContentfulBlockId } from 'utils/contentful';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import RichText from './RichText';
import styles from './Timeline.module.scss';
import type { InspectorPropsType } from 'hooks/useLivePreview';
import type { IBlockTimelineFields } from 'types/contentful/generated';
import type { Document } from '@contentful/rich-text-types';

type Props = IBlockTimelineFields & {
  descriptionContent?: Document;
  inspectorProps?: InspectorPropsType;
};

const Timeline = ({
  blockId,
  title,
  description,
  descriptionContent,
  items,
  // eslint-disable-next-line
  // @ts-ignore
  timelineItems,
  inspectorProps,
}: Props): JSX.Element => {
  // eslint-disable-next-line
  // @ts-ignore
  const tmlItems = timelineItems ? timelineItems.items : items;

  return (
    <div id={sanitizeContentfulBlockId(blockId)} className={styles.container}>
      {title && (
        <h2
          className={styles.headline}
          {...inspectorProps?.({ fieldId: 'title' })}
        >
          {title}
        </h2>
      )}
      {(descriptionContent || description) && (
        <div className={styles.description}>
          <RichText fields={descriptionContent || description} />
        </div>
      )}
      <ul className={styles.timeline}>
        {
          // eslint-disable-next-line
          // @ts-ignore
          tmlItems.map((item, i) => {
            const {
              description: itemDescription,
              isClosingItem,
              descriptionContent,
              title: itemTitle,
            } = item.fields || item;

            const descriptionFields = itemDescription || descriptionContent;

            const inspectorPropsForItems = useContentfulInspectorMode({
              entryId: item?.sys?.id,
            });

            return (
              <li key={i}>
                <p
                  className={styles.title}
                  {...inspectorPropsForItems?.({
                    fieldId: 'title',
                  })}
                >
                  {itemTitle}
                </p>
                <div
                  className={clsx(styles.content, isClosingItem && 'pb-4')}
                  style={
                    !isClosingItem
                      ? {
                          backgroundImage: `url(${IMGS_PATH.PUBLIC}/line_time.svg)`,
                        }
                      : {}
                  }
                >
                  {descriptionFields && (
                    <RichText
                      fields={descriptionFields}
                      inspectorProps={{
                        ...inspectorPropsForItems?.({
                          fieldId: 'descriptionContent',
                        }),
                      }}
                    />
                  )}
                </div>
              </li>
            );
          })
        }
      </ul>
    </div>
  );
};

export default Timeline;
